import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import '../styles/LegalPages.css';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page" data-testid="datenschutz-page">
      <button className="legal-back-btn" onClick={() => navigate(-1)} data-testid="back-btn">
        <ArrowLeft size={18} /> Zurück
      </button>

      <div className="legal-content">
        <h1>Datenschutzerklärung</h1>

        <section>
          <h2>1. Verantwortlicher</h2>
          <p>
            WE LUV TO CELEBRATE GmbH<br />
            Hertelstraße 31, 01307 Dresden<br />
            Markus Recknagel<br />
            E-Mail: <a href="mailto:hello@weluvtocelebrate.com">hello@weluvtocelebrate.com</a><br />
            Telefon: 0176 19904996
          </p>
        </section>

        <section>
          <h2>2. Erhebung und Speicherung personenbezogener Daten</h2>
          <p>
            Beim Besuch unserer Webseite wedding-o-mat.com werden folgende Daten erhoben:
          </p>
          <ul>
            <li><strong>Quiz-Antworten:</strong> Ihre Antworten im Wedding-O-Mat Quiz werden gespeichert, 
            um Ihnen personalisierte Destinationsvorschläge zu berechnen.</li>
            <li><strong>Kontaktdaten:</strong> Wenn Sie Ihre Ergebnisse per E-Mail erhalten möchten, 
            geben Sie freiwillig Ihren Namen, Ihren Ort und Ihre E-Mail-Adresse an.</li>
            <li><strong>Newsletter:</strong> Wenn Sie sich für den Newsletter anmelden, wird Ihre 
            E-Mail-Adresse für den Versand von Informationen zu Destinationen und Angeboten gespeichert.</li>
          </ul>
        </section>

        <section>
          <h2>3. Zweck der Datenverarbeitung</h2>
          <p>Ihre Daten werden ausschließlich zu folgenden Zwecken verwendet:</p>
          <ul>
            <li>Berechnung und Anzeige Ihrer personalisierten Wedding-Destination-Ergebnisse</li>
            <li>Versand der Ergebnis-E-Mail an Sie und an unser Team zur Kontaktaufnahme</li>
            <li>Versand von Newsletter-Informationen (nur bei expliziter Anmeldung)</li>
            <li>Statistische Auswertung der Quiz-Nutzung (anonymisiert)</li>
          </ul>
        </section>

        <section>
          <h2>4. Rechtsgrundlage</h2>
          <p>
            Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) 
            für die E-Mail-Zusendung und den Newsletter sowie Art. 6 Abs. 1 lit. f DSGVO 
            (berechtigtes Interesse) für die Berechnung der Quiz-Ergebnisse und anonymisierte Statistiken.
          </p>
        </section>

        <section>
          <h2>5. Drittanbieter und Datenübermittlung</h2>
          <p>Wir nutzen folgende Dienste zur Bereitstellung unserer Webseite:</p>
          <ul>
            <li><strong>Railway (Hosting):</strong> Unsere Webseite wird auf Railway-Servern gehostet. 
            Dabei können Zugriffsdaten (IP-Adresse, Zeitstempel) technisch bedingt protokolliert werden.</li>
            <li><strong>MongoDB Atlas (Datenbank):</strong> Ihre Quiz-Antworten und Kontaktdaten werden 
            in einer MongoDB-Atlas-Datenbank gespeichert. Die Server befinden sich in der EU bzw. 
            unterliegen den Standardvertragsklauseln.</li>
            <li><strong>Resend (E-Mail-Versand):</strong> Für den Versand der Ergebnis-E-Mails nutzen 
            wir den Dienst Resend. Dabei werden Ihr Name und Ihre E-Mail-Adresse an Resend übermittelt.</li>
            <li><strong>Cloudinary (Medien):</strong> Bilder der Destinationen werden über Cloudinary 
            bereitgestellt. Beim Laden dieser Bilder kann Ihre IP-Adresse an Cloudinary übermittelt werden.</li>
          </ul>
        </section>

        <section>
          <h2>6. Cookies und lokale Speicherung</h2>
          <p>
            Unsere Webseite verwendet <strong>keine Tracking-Cookies</strong> und keine 
            Analyse-Tools wie Google Analytics. Wir speichern lediglich:
          </p>
          <ul>
            <li><strong>LocalStorage:</strong> Ihren Quiz-Fortschritt und Ihre Sprachauswahl, 
            damit Sie das Quiz unterbrechen und fortsetzen können. Diese Daten verbleiben 
            ausschließlich in Ihrem Browser und werden nicht an uns übermittelt.</li>
            <li><strong>Cookie-Einwilligung:</strong> Ihre Auswahl bezüglich des Cookie-Banners 
            wird lokal gespeichert.</li>
          </ul>
        </section>

        <section>
          <h2>7. Ihre Rechte</h2>
          <p>Sie haben jederzeit das Recht auf:</p>
          <ul>
            <li>Auskunft über Ihre bei uns gespeicherten Daten (Art. 15 DSGVO)</li>
            <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
            <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
            <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
          </ul>
          <p>
            Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: 
            <a href="mailto:hello@weluvtocelebrate.com">hello@weluvtocelebrate.com</a>
          </p>
        </section>

        <section>
          <h2>8. Speicherdauer</h2>
          <p>
            Ihre personenbezogenen Daten werden gelöscht, sobald der Zweck der Speicherung entfällt. 
            Quiz-Ergebnisse und Kontaktdaten werden für die Dauer der Geschäftsbeziehung gespeichert. 
            Sie können jederzeit die Löschung Ihrer Daten beantragen.
          </p>
        </section>

        <section>
          <h2>9. Änderungen dieser Datenschutzerklärung</h2>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den 
            aktuellen rechtlichen Anforderungen entspricht. Die jeweils aktuelle Fassung gilt 
            für Ihren erneuten Besuch.
          </p>
          <p><em>Stand: Februar 2026</em></p>
        </section>
      </div>
    </div>
  );
};

export default Datenschutz;
